import useSWR from "swr";
import { GeoJsonDeliverableBody } from "react-migration/lib/map/GenericGeoJsonLayer/types";

export function useGeoJsonDeliverable(signedUrl?: string) {
  const { data, ...rest } = useSWR<GeoJsonDeliverableBody>(signedUrl, jsonFetcher);

  return { geojson: data, ...rest };
}

const jsonFetcher = (url: string) => fetch(url).then((res) => res.json());
